
  var _styles = {
  "mock-switcher": {
    "position": "absolute",
    "right": "0.21333rem",
    "bottom": "2.93333rem",
    "zIndex": 99999,
    "flexDirection": "column",
    "alignItems": "flex-end"
  },
  "mock-switcher__fab": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.74667rem",
    "paddingTop": 0,
    "paddingRight": "0.26667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.26667rem",
    "borderRadius": "0.37333rem",
    "backgroundColor": "rgba(0,0,0,0.72)"
  },
  "mock-switcher__fab-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "500"
  },
  "mock-switcher__panel": {
    "width": "3.73333rem",
    "maxHeight": "7.46667rem",
    "marginBottom": "0.16rem",
    "padding": "0.10667rem",
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgba(0,0,0,0.85)"
  },
  "mock-switcher__list": {
    "maxHeight": "7.25333rem"
  },
  "mock-switcher__item": {
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.85333rem",
    "paddingTop": 0,
    "paddingRight": "0.21333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.21333rem",
    "marginBottom": "0.05333rem",
    "borderRadius": "0.10667rem"
  },
  "mock-switcher__item--active": {
    "backgroundColor": "rgb(255,45,25)"
  },
  "mock-switcher__item-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  }
};



  module.exports = _styles;
  